import React from 'react';
import ReactDOM from 'react-dom';
import '../less/owners.less';
import FilesForDownloadNew from '../../../auxiliary-components/shared/FilesForDownloadNew';
import Preloader from 'MWComponents/dest/components/Preloader';
import CustomDropdown from "../../../auxiliary-components/shared/CustomDropdownNew";
import {canUseDOM} from '../../../helpers/canUseDOM';
import { Link, Table, DropDown} from 'MWC';
import TitleBlock from "../../../auxiliary-components/shared/TitleBlock/views/TitleBlock";
import file_img from '../img/file_icon.svg';
import { splitLastWord } from '../../../helpers/utils/splitLastWord';
import DOMPurify from 'utils/sanitize';

export default function template() {
  generateThead = generateThead.bind(this);
  generateBody = generateBody.bind(this);
  getRowCells = getRowCells.bind(this);
  generateCell = generateCell.bind(this);
  generateMobileThead = generateMobileThead.bind(this);

  const isMobile = this.state.isMobileTable,
    tablesSelectedData = this.state.tablesSelectedData,
    tables = this.state.data.length ?
      (this.state.data.map(table => {
        const options = table.columns.map(column => {
          return {id: column.id, name: column[`name_${this.props.lang}`]}
        });

        return (
          <CustomDropdown chevron_icon title={table[`period_${this.props.lang}`]} key={table.id} titleTag={"h3"}>
            <div className="table-scroll-wrapper">
            <Table className="custom-table">
              <thead>
              <tr>
                <th colSpan={isMobile ? 2 : 5} className="top-header text-center">
                  {table[`table_name_${this.props.lang}`]}
                </th>
              </tr>
              <tr className="table-header" key={table.id}>
                <th className="second-header label">
                  {this.l10n('ABOUT_OWNERS_MEETING_TH_DATE')}
                </th>
                { isMobile ? generateMobileThead(table.id, options): generateThead(table.columns)}
              </tr>
              </thead>
              <tbody>{generateBody(table.id, table.rows, table.columns)}</tbody>
            </Table>
            </div>
          </CustomDropdown>
        )
      }))
      : '';
  function generateMobileThead(id, options)  {
    return (
      <th className="second-header">
        <div className="drop-wrapper">
          <DropDown
            name="terms"
            onChange={(e) => this.select(e, options, id)}
            value={tablesSelectedData[id].id}
            className="custom-select-table"
            collection={options}
          />
        </div>
      </th>
    )
  }
  function generateThead(data)  {
    return (
      data.map(column => {
        const { before, lastWord } = splitLastWord(column[`name_${this.props.lang}`]);
        return (
          <th key={column.id} className="second-header">
            {column.description_ua ?
              (
                <span className="header-with-notice" key={column.id}>
                  {before}
                  <span style={{whiteSpace: 'nowrap'}}>
                    {lastWord}
                    <span
                      className="table-notice"
                      onMouseEnter={(e) => this.showTooltip(e, column[`description_${this.props.lang}`])}
                      onMouseLeave={this.hideTooltip}
                    >
                      <span className="icon"></span>
                    </span>
                  </span>
                </span>
              ) : column[`name_${this.props.lang}`]}
          </th>
        )
      })
    )
  }
  function generateBody(id, rows, columns) {
    return rows.map(row => {
      return (
        <tr className={'table-body'} key={row.id}>
          <td>{row.meeting_date}</td>
          {getRowCells(id, columns, row)}
        </tr>
      )
    })
  }
  function getRowCells(tableId, columns, row) {
    return columns.map( column => {
      const td = (<td key={column.id}>{generateCell(column, row)}</td>);
      if (isMobile) {
        if (tablesSelectedData[tableId].id === column.id) {
          return td
        }
      } else {
        return td
      }
    })
  }
  function generateCell(column, row) {
    return row.items.map(item => {
      if (item.column_id === column.id) {
        return (
          item.file ?
            (<div key={`${column.id}-${item.id}`}>
              <Link
                href={this.changeFilesUrl(item.file)}
                target="_blank"
                className="link-item"
              >
                  <img src={file_img} className='file-img'/>
                <span>&nbsp;{item[`name_${this.props.lang}`]}</span>
              </Link>
            </div>)
            :
            <div key={item.id}>{item[`name_${this.props.lang}`]}</div>
        )
      }
    })
  };
  const { tooltipNotice } = this.state;
  const tooltip = tooltipNotice.visible && canUseDOM
    ? ReactDOM.createPortal(
        <div
          className="owners-bubble-portal"
          style={{ left: tooltipNotice.x, top: tooltipNotice.y }}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(tooltipNotice.html) }}
        />,
        document.body
      )
    : null;

    return (
        <div className="module-about-owners">
          {tooltip}
              {this.state.loader ? (canUseDOM ? <Preloader /> : null) : <FilesForDownloadNew widget={this.widgetsHelper.getWidget_2.call(this, "files_to_download")}/>}
              {this.state.loader ? (canUseDOM ? <Preloader /> : null) : <FilesForDownloadNew widget={this.widgetsHelper.getWidget_3.call(this, "files_to_download")}/>}
              {this.state.loader ? (canUseDOM ? <Preloader /> : null) : <FilesForDownloadNew widget={this.widgetsHelper.getWidget.call(this, "files_to_download")}/>}
              <div ref={this.esgRef}>
                {this.state.widgets_4_loading ? (canUseDOM ? <Preloader /> : null) : <FilesForDownloadNew widget={this.widgetsHelper.getWidgetFrom.call(this, 'widgets_4', 'files_to_download')}/>}
              </div>
              <div className="info-wrapper">
                  <TitleBlock title={'ABOUT_OWNERS_CUT_MEETINGS'} tag='h2' />
                {this.state.meetingsLoading ? (canUseDOM ? <Preloader /> : null) : tables}
              </div>
        </div>
    );
}
